const DEFAULT_COLUMNS = 12;
const ITEM_LAYOUT_DEFAULTS = {
    column: 0,
    height: 1
};
export function normalizeFormSchema(form) {
    const normalized = {
        ...form
    };
    if (form.nestedForms) {
        normalized.nestedForms = form.nestedForms.map((nestedForm)=>nestedForm.form ? {
                ...nestedForm,
                form: normalizeFormSchema(nestedForm.form)
            } : nestedForm);
    }
    if (form.steps) {
        const fields = form.fields ?? form.formFields ?? [];
        const fallbackStepIndex = form.steps.some(hasPositionedItems) ? -1 : 0;
        normalized.steps = form.steps.map((step, index)=>normalizeStep(step, index === fallbackStepIndex ? fields : []));
    }
    return normalized;
}
function hasPositionedItems(step) {
    return Boolean(step.layout?.large?.items?.length);
}
function normalizeStep(step, fields) {
    return {
        ...step,
        layout: normalizeLayout(step.layout ?? {}, fields)
    };
}
function normalizeLayout(layout, fields) {
    const columns = layout.large?.columns ?? DEFAULT_COLUMNS;
    const normalized = {
        ...layout,
        large: normalizeBreakPoint(layout.large, columns, fields)
    };
    if (layout.small) {
        normalized.small = normalizeBreakPoint(layout.small, columns);
    }
    return normalized;
}
function normalizeBreakPoint(breakPoint = {}, parentColumns, fallbackFields = []) {
    const columns = breakPoint.columns ?? parentColumns;
    const items = breakPoint.items?.length ? breakPoint.items : toUnpositionedItems(fallbackFields);
    return {
        ...breakPoint,
        items: items.map((item, index)=>({
                ...item,
                row: item.row ?? index,
                column: item.column ?? ITEM_LAYOUT_DEFAULTS.column,
                width: item.width ?? columns,
                height: item.height ?? ITEM_LAYOUT_DEFAULTS.height
            }))
    };
}
function toUnpositionedItems(fields) {
    return fields.flatMap(({ id })=>id ? [
            {
                fieldId: id
            }
        ] : []);
}

//# sourceMappingURL=normalize-form-schema.js.map